// tabs section component
import imkt from '../../imkt';
import url from '../../utils/url';

export default class Tabs {
  domRoot: HTMLElement;
  params: any;
  defaultTabName: any;
  tabs: any;
  tabLinks: any;
  tabIcon: any;
  tabBlocks: any;
  tabDescriptions: any;
  activeBlockClass: string;
  inactiveTabClasses: string;
  activeTabClasses: string;
  componentRoot: HTMLElement;
  dropdown: HTMLElement;
  dropdownSelection: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.params = params;
    // component elements
    this.defaultTabName = params.firstTabName;
    this.tabs = this.domRoot.querySelectorAll('.imkt-tab, .tab-dropdown-option');
    this.tabLinks = this.domRoot.querySelectorAll('.imkt-tab a, .tab-dropdown-option a');
    this.tabIcon = this.domRoot.querySelectorAll('.imkt-tab img, .tab-dropdown-option img');
    this.tabBlocks = this.domRoot.querySelectorAll('.imkt-tab-block');
    this.tabDescriptions = this.domRoot.querySelectorAll('.imkt-tab-description');
    this.activeBlockClass = "active";
    this.inactiveTabClasses = params.tabBackgroundColor + " text-" + params.tabTextColor + " border-color-" + params.tabBorderColor;
    this.activeTabClasses = "active " + params.tabBackgroundColorActive + " text-" + params.tabTextColorActive + " border-color-" + params.tabBorderColor;
    this.componentRoot = domRoot;
    this.dropdown = document.getElementById(this.params.selectId) as HTMLElement;
    this.dropdownSelection = this.componentRoot.querySelector('.mobile-tab-navigation > button');
    this.init();
  }

  init() {
    this.bindEvents();
    this.setInitialState();
    console.log(this.params.defaultTab)
  }

  setInitialState() {
    var urlParams = url.getUrlParams();
    this.closeTabs();
    if (urlParams !== null && urlParams.tab !== undefined) {
      this.openTabByName(urlParams.tab);

      // if URL contains an anchor tag that is not on the
      // default tab jump to it after opening the tab
      if (window.location.hash && document.querySelector(window.location.hash)) {
        window.location = window.location.hash;
      }
    } else {
      this.openTabByName(this.params.defaultTab);
    }
  }

  bindEvents() {
    var self = this;
    if (self.params.linkedContainerTab) {
      document.body.addEventListener('tabClicked', () => {
        self.setInitialState();
      }, false);
    }
    Array.from(this.tabLinks).forEach(tabLink => {
      tabLink.addEventListener('click', (e) => {
        e.preventDefault();
        this.openTab(e);
        if (self.params.linkedContainerTab) {

          var event = document.createEvent('Event');
          event.initEvent('tabClicked', true, true);
          document.body.dispatchEvent(event);
        }
        e.preventDefault();
      })
    });

    if (this.dropdown && this.dropdownSelection) {
      let optionsList = this.dropdown.querySelector('.tab-dropdown-options');
      let options = optionsList.querySelectorAll('.tab-dropdown-option');
      let tabIndex = null;
      let selectedTab = null;

      this.dropdownSelection.addEventListener('click', () => {
        this.dropdown.classList.toggle(this.activeBlockClass);
      });

      this.dropdown.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') {
          e.preventDefault();
        }

        let acceptableKeys = ['ArrowDown', 'ArrowUp', 'Enter', 'Escape', 'Home', 'End'];
        if (acceptableKeys.includes(e.key)) {
          for (var i = 0; i < options.length; i += 1) {
            options[i].classList.remove(this.activeBlockClass);
          }
          if (e.key === 'ArrowDown') {
            tabIndex = (tabIndex !== null && tabIndex < options.length - 1) ? tabIndex + 1 : 0;
            options[tabIndex].classList.add(this.activeBlockClass);
            selectedTab = options[tabIndex];
          }
          if (e.key === 'ArrowUp') {
            tabIndex = tabIndex ? tabIndex - 1 : options.length - 1;
            options[tabIndex].classList.add(this.activeBlockClass);
            selectedTab = options[tabIndex];
          }
          if (e.key === 'Home') {
            tabIndex = 0;
            options[tabIndex].classList.add(this.activeBlockClass);
            selectedTab = options[tabIndex];
          }
          if (e.key === 'End') {
            tabIndex = options.length - 1;
            options[tabIndex].classList.add(this.activeBlockClass);
            selectedTab = options[tabIndex];
          }
          if (e.key === 'Enter') {
            this.dropdown.classList.toggle(this.activeBlockClass);
            if (selectedTab) {
              let tab = selectedTab.querySelector('a');
              this.openTabByName(tab.dataset.tabName);
              this.updateHistory(tab.dataset.tabName);
              selectedTab = null;
            }
          }
          if (e.key === 'Escape') {
            this.dropdown.classList.remove(this.activeBlockClass);
            selectedTab = null;
          }
        }
      });

      window.addEventListener('click', (e) => {
        if (e.target !== this.dropdownSelection) {
          this.dropdown.classList.remove(this.activeBlockClass);
        }
      });
    }

  }

  openTab(clicked) {
    this.closeTabs();
    this.updateHistory(clicked.target.dataset.tabName);
    clicked.target.className = this.activeTabClasses;
    clicked.target.setAttribute('aria-selected', 'true');
    if (this.domRoot.querySelector(clicked.target.hash)) {
      this.domRoot.querySelector(clicked.target.hash).classList.add(this.activeBlockClass);
    }
    if (this.domRoot.querySelector(clicked.target.hash + '-description')) {
      this.domRoot.querySelector(clicked.target.hash + '-description').classList.add(this.activeBlockClass);
    }
    this.openDropdownTab(clicked);

    window.dispatchEvent(new Event('resize'));
  }

  openDropdownTab(clicked) {
    if (this.dropdown) {
      let selectedTab = this.componentRoot.querySelectorAll('[data-tab-name="' + clicked.target.dataset.tabName + '"]');
      let dropdownOption = this.dropdown.querySelector('[data-tab-name="' + clicked.target.dataset.tabName + '"]');
      selectedTab.className = this.activeTabClasses;
      this.dropdownSelection.textContent = dropdownOption.textContent;
    }
  }

  openTabByName(tabName) {
    var tab = this.domRoot.querySelector('.imkt-tab > [data-tab-name="' + tabName + '"]');
    if (!tab) {
      tab = this.domRoot.querySelector('.imkt-tab > [data-tab-name="' + this.params.defaultTab + '"]');
    }
    var tabBlock = this.domRoot.querySelector(tab.getAttribute('href'));
    var tabDescription = this.domRoot.querySelector(tab.getAttribute('href') + '-description');

    this.closeTabs();
    tab.className = '';
    tab.className = this.activeTabClasses;
    tab.setAttribute('aria-selected', 'true');
    tabBlock.classList.add(this.activeBlockClass);
    if (tabDescription) {
      tabDescription.classList.add(this.activeBlockClass);
    }

    this.openDropdownTabByName(tabName);
  }

  openDropdownTabByName(tabName) {
    if (this.dropdown) {
      let dropdownOption = this.dropdown.querySelector('[data-tab-name="' + tabName + '"]');
      if (dropdownOption) {
        dropdownOption.classList.add(this.activeBlockClass);
        this.dropdownSelection.textContent = dropdownOption.textContent;
      }
    }
  }

  closeTabs() {
    Array.from(this.tabBlocks).forEach(tabBlock => {
      tabBlock.classList.remove(this.activeBlockClass);
    });
    Array.from(this.tabDescriptions).forEach(tabBlock => {
      tabBlock.classList.remove(this.activeBlockClass);
    });
    Array.from(this.tabLinks).forEach(tabLink => {
      tabLink.className = this.inactiveTabClasses;
      tabLink.setAttribute('aria-selected', 'false');
    });
  }

  updateHistory(tabName) {
    if (imkt.core.supports.history()) {
      // Append url params from incoming URL on history state
      if (typeof tabName !== typeof undefined && tabName !== false) {
        var currentUrl = window.location.href;
        var urlParams = url.getUrlParams(currentUrl);
        var hash = window.location.hash;

        if (urlParams) {
          urlParams['tab'] = tabName;
        } else {
          urlParams = { tab: tabName };
        }
        window.history.replaceState(tabName, document.title, "?" + new URLSearchParams(Object.entries(urlParams)).toString() + hash);
      }
    }
  }
}

